<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <h2>Cambiar contraseña</h2>
    </md-card-header>

    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Contraseña actual</label>
            <md-input v-model="old_password" type="password"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Nueva contraseña</label>
            <md-input v-model="password" type="password"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-100">
          <md-field>
            <label>Confirmar contraseña</label>
            <md-input v-model="confirmed_password" type="password"></md-input>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-100"
          v-show="isFilled && !samePassword"
        >
          <p class="text-center text-warning">Las contraseñas no coinciden</p>
        </div>

        <div class="md-layout-item md-size-25 ml-auto">
          <md-button @click="submit" class="md-primary" :disabled="!valid">
            Cambiar
          </md-button>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>

export default {
  name: 'ChangePassword',
  data() {
    return {
      password: null,
      confirmed_password: null,
      old_password: null,
    }
  },
  computed: {
    samePassword() {
      if (this.password !== null && this.confirmed_password !== null) {
        return this.password === this.confirmed_password
      }
      return false
    },
    isFilled() {
      return this.password !== null && this.samePassword !== null && this.old_password !== null
    },
    valid() {
      return this.isFilled === true && this.samePassword === true
    }
  },
  methods: {
    submit() {
      const data = {
        old_password: this.old_password,
        password: this.password,
        confirmed_password: this.confirmed_password
      }
      this.$http.put('/user/current/change_password/', data).then(
        () => {
          this.$successMessage({title: 'Contraseña actualizada'})
          this.$router.push({name: 'Perfil de usuario'})
        }
      ).catch(this.$fireErrorResponse)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/UserProfileComponents/ChangePassword.vue